// Modal Video Trigger Component with Animations
class ModalVideoTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.template = this.querySelector("template");
    this.videoId = this.getAttribute("data-video-id");

    if (!this.button || !this.template) return;

    this.button.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    // Create or get existing modal
    let modal = document.querySelector("#video-modal");
    if (!modal) {
      modal = this.createModal();
      document.body.appendChild(modal);
    }

    // Load video content into modal
    this.loadVideoIntoModal(modal);

    // Show modal with animation
    this.showModal(modal);
  }

  createModal() {
    const modal = document.createElement("div");
    modal.id = "video-modal";
    modal.className = "video-modal";
    modal.setAttribute("aria-label", "Video player");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");

    modal.innerHTML = `
      <div class="video-modal__backdrop"></div>
      <div class="video-modal__content">
        <button class="video-modal__close" aria-label="Close video">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="video-modal__media"></div>
      </div>
    `;

    // Add close functionality
    const closeBtn = modal.querySelector(".video-modal__close");
    const backdrop = modal.querySelector(".video-modal__backdrop");

    closeBtn.addEventListener("click", () => this.closeModal(modal));
    backdrop.addEventListener("click", () => this.closeModal(modal));

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        modal.classList.contains("video-modal--active")
      ) {
        this.closeModal(modal);
      }
    });

    return modal;
  }

  showModal(modal) {
    // Disable page scroll
    document.body.style.overflow = "hidden";

    // Show modal
    modal.style.display = "flex";

    // Force reflow before adding active class for animation
    modal.offsetHeight;

    // Add active class for animation
    modal.classList.add("video-modal--active");

    // Focus trap
    this.trapFocus(modal);
  }

  closeModal(modal) {
    // Remove active class for fade out animation
    modal.classList.remove("video-modal--active");

    // Wait for animation to complete before hiding
    setTimeout(() => {
      modal.style.display = "none";

      // Re-enable page scroll
      document.body.style.overflow = "";

      // Pause and remove media
      const mediaContainer = modal.querySelector(".video-modal__media");
      const videoElement = mediaContainer.querySelector("video, iframe");

      if (videoElement) {
        if (videoElement.nodeName === "VIDEO") {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
        mediaContainer.innerHTML = "";
      }
    }, 300); // Match CSS transition duration
  }

  loadVideoIntoModal(modal) {
    const mediaContainer = modal.querySelector(".video-modal__media");

    // Clear existing content
    mediaContainer.innerHTML = "";

    // Pause all other media
    this.pauseAllMedia();

    // Clone and append video content
    const videoContent = this.template.content.cloneNode(true);
    const videoElement = videoContent.querySelector("video, iframe");

    if (videoElement) {
      mediaContainer.appendChild(videoElement);

      // Auto-focus and play after a brief delay for smooth animation
      setTimeout(() => {
        if (videoElement.nodeName === "VIDEO") {
          videoElement.play().catch((e) => {
            console.log("Autoplay prevented:", e);
          });
        }
      }, 400);
    }
  }

  trapFocus(modal) {
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    // Focus first element
    firstElement.focus();

    modal.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }

  pauseAllMedia() {
    // Pause all videos on the page
    document.querySelectorAll("video").forEach((video) => {
      video.pause();
    });

    // Stop YouTube/Vimeo if needed
    document
      .querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]')
      .forEach((iframe) => {
        const src = iframe.src;
        if (src.includes("autoplay=1")) {
          iframe.src = src.replace("autoplay=1", "autoplay=0");
          iframe.src = src;
        }
      });
  }
}

// Register the custom element
customElements.define("modal-video-trigger", ModalVideoTrigger);

// // UI Accordion Component
// class UIAccordion extends HTMLElement {
//   constructor() {
//     super();

//     this.question = this.querySelector(".ui-accordion__question");
//     this.answer = this.querySelector(".ui-accordion__answer");
//     this.isOpen = false;

//     if (!this.question || !this.answer) return;

//     this.setupAccordion();
//   }

//   setupAccordion() {
//     // Wrap content and add button
//     this.innerHTML = `
//       <button class="ui-accordion__trigger" aria-expanded="false">
//         <span class="ui-accordion__question-text">${this.question.innerHTML}</span>
//         <span class="ui-accordion__icon" aria-hidden="true"></span>
//       </button>
//       <div class="ui-accordion__content">
//         <div class="ui-accordion__answer-wrapper">
//           ${this.answer.outerHTML}
//         </div>
//       </div>
//     `;

//     // Get new references
//     this.trigger = this.querySelector(".ui-accordion__trigger");
//     this.content = this.querySelector(".ui-accordion__content");
//     this.answerWrapper = this.querySelector(".ui-accordion__answer-wrapper");

//     // Set initial state
//     this.content.style.height = "0px";
//     this.content.style.overflow = "hidden";

//     // Add click listener
//     this.trigger.addEventListener("click", this.toggle.bind(this));

//     // Add keyboard support
//     this.trigger.addEventListener("keydown", (e) => {
//       if (e.key === "Enter" || e.key === " ") {
//         e.preventDefault();
//         this.toggle();
//       }
//     });
//   }

//   toggle() {
//     if (this.isOpen) {
//       this.close();
//     } else {
//       this.open();
//     }
//   }

//   open() {
//     this.isOpen = true;
//     this.classList.add("ui-accordion--open");
//     this.trigger.setAttribute("aria-expanded", "true");

//     // Get the height of the content
//     const height = this.answerWrapper.scrollHeight;

//     // Set height for animation
//     this.content.style.height = height + "px";

//     // After animation completes, set to auto for responsive behavior
//     setTimeout(() => {
//       if (this.isOpen) {
//         this.content.style.height = "auto";
//       }
//     }, 300);
//   }

//   close() {
//     this.isOpen = false;
//     this.classList.remove("ui-accordion--open");
//     this.trigger.setAttribute("aria-expanded", "false");

//     // Get current height first
//     const height = this.answerWrapper.scrollHeight;
//     this.content.style.height = height + "px";

//     // Force reflow
//     this.content.offsetHeight;

//     // Animate to 0
//     this.content.style.height = "0px";
//   }
// }

// // Register the custom element
// customElements.define("ui-accordion", UIAccordion);

// UI Accordion Component
class UIAccordion extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".ui-accordion__trigger");
    this.content = this.querySelector(".ui-accordion__content");
    this.answerWrapper = this.querySelector(".ui-accordion__answer-wrapper");
    this.isOpen = false;

    if (!this.trigger || !this.content || !this.answerWrapper) return;

    this.setupAccordion();
  }

  setupAccordion() {
    // Set initial state
    this.content.style.height = "0px";
    this.content.style.overflow = "hidden";
    this.trigger.setAttribute("aria-expanded", "false");

    // Add click listener
    this.trigger.addEventListener("click", this.toggle.bind(this));

    // Add keyboard support
    this.trigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.toggle();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.classList.add("ui-accordion--open");
    this.trigger.setAttribute("aria-expanded", "true");

    // Get the height of the content
    const height = this.answerWrapper.scrollHeight;

    // Set height for animation
    this.content.style.height = height + "px";

    // After animation completes, set to auto for responsive behavior
    setTimeout(() => {
      if (this.isOpen) {
        this.content.style.height = "auto";
      }
    }, 300);
  }

  close() {
    this.isOpen = false;
    this.classList.remove("ui-accordion--open");
    this.trigger.setAttribute("aria-expanded", "false");

    // Get current height first
    const height = this.answerWrapper.scrollHeight;
    this.content.style.height = height + "px";

    // Force reflow
    this.content.offsetHeight;

    // Animate to 0
    this.content.style.height = "0px";
  }
}

// Register the custom element
customElements.define("ui-accordion", UIAccordion);

// // Debug Ingredient Glossary Filter Component
// class IngredientsGlossary extends HTMLElement {
//   constructor() {
//     super();

//     this.filterButtons = this.querySelectorAll("[data-filter]");
//     this.ingredientCards = this.querySelectorAll("[data-category]");
//     this.currentFilter = "all";

//     console.log("=== INGREDIENTS GLOSSARY DEBUG ===");
//     console.log("Filter buttons found:", this.filterButtons.length);
//     console.log("Ingredient cards found:", this.ingredientCards.length);

//     if (!this.filterButtons.length || !this.ingredientCards.length) return;

//     this.debugData();
//     this.setupFilters();
//   }

//   debugData() {
//     console.log("\n=== FILTER BUTTONS DEBUG ===");
//     this.filterButtons.forEach((button, index) => {
//       const filter = button.getAttribute("data-filter");
//       const text = button.textContent.trim();
//       console.log(`Button ${index}: filter="${filter}", text="${text}"`);
//     });

//     console.log("\n=== INGREDIENT CARDS DEBUG ===");
//     this.ingredientCards.forEach((card, index) => {
//       const categories = card.getAttribute("data-category");
//       const title =
//         card
//           .querySelector(".ingredients-glossary__title")
//           ?.textContent.trim() || "No title";
//       console.log(`Card ${index} (${title}): categories="${categories}"`);

//       if (categories) {
//         const categoryArray = categories.split(",").map((cat) => cat.trim());
//         console.log(`  - Parsed categories:`, categoryArray);
//       }
//     });
//   }

//   setupFilters() {
//     this.filterButtons.forEach((button) => {
//       button.addEventListener("click", (e) => {
//         e.preventDefault();
//         const filter = button.getAttribute("data-filter");
//         console.log(`\n=== FILTER CLICKED: ${filter} ===`);
//         this.setActiveFilter(filter);
//       });
//     });

//     // Set initial state
//     this.setActiveFilter("all");
//   }

//   setActiveFilter(filter) {
//     this.currentFilter = filter;

//     // Update active button
//     this.filterButtons.forEach((button) => {
//       const buttonFilter = button.getAttribute("data-filter");
//       if (buttonFilter === filter) {
//         button.classList.add("filter-button--active");
//         button.setAttribute("aria-pressed", "true");
//       } else {
//         button.classList.remove("filter-button--active");
//         button.setAttribute("aria-pressed", "false");
//       }
//     });

//     // Filter ingredients
//     this.filterIngredients(filter);
//   }

//   filterIngredients(filter) {
//     console.log(`Filtering by: "${filter}"`);
//     let visibleCount = 0;
//     let hiddenCount = 0;

//     this.ingredientCards.forEach((card, index) => {
//       const cardCategories = card.getAttribute("data-category");
//       const title =
//         card
//           .querySelector(".ingredients-glossary__title")
//           ?.textContent.trim() || `Card ${index}`;

//       console.log(`\nChecking ${title}:`);
//       console.log(`  Categories: "${cardCategories}"`);

//       if (!cardCategories || cardCategories.trim() === "") {
//         console.log(`  → HIDDEN (no categories)`);
//         this.hideCard(card);
//         hiddenCount++;
//         return;
//       }

//       const categoryArray = cardCategories
//         .split(",")
//         .map((cat) => cat.trim())
//         .filter((cat) => cat.length > 0);

//       console.log(`  Parsed: [${categoryArray.join(", ")}]`);

//       const shouldShow = filter === "all" || categoryArray.includes(filter);
//       console.log(`  Filter "${filter}" matches: ${shouldShow}`);

//       if (shouldShow) {
//         console.log(`  → SHOWN`);
//         this.showCard(card);
//         visibleCount++;
//       } else {
//         console.log(`  → HIDDEN`);
//         this.hideCard(card);
//         hiddenCount++;
//       }
//     });

//     console.log(
//       `\nFilter result: ${visibleCount} shown, ${hiddenCount} hidden`
//     );
//   }

//   showCard(card) {
//     card.style.display = "block";
//     card.style.opacity = "1";
//     card.classList.add("ingredient-card--visible");
//   }

//   hideCard(card) {
//     card.style.opacity = "0.3"; // Make it semi-transparent instead of hiding for debugging
//     card.classList.remove("ingredient-card--visible");
//     // Don't hide completely for debugging
//     // card.style.display = "none";
//   }
// }

// // Register the custom element
// customElements.define("ingredients-glossary", IngredientsGlossary);

// Smooth Ingredient Glossary Filter Component
class IngredientsGlossary extends HTMLElement {
  constructor() {
    super();

    this.filterButtons = this.querySelectorAll("[data-filter]");
    this.ingredientCards = this.querySelectorAll("[data-category]");
    this.currentFilter = "all";

    if (!this.filterButtons.length || !this.ingredientCards.length) return;

    this.setupFilters();
    this.initializeCards();
  }

  initializeCards() {
    // Set initial state for all cards
    this.ingredientCards.forEach((card) => {
      card.style.display = "block";
      card.style.opacity = "1";
      card.style.transform = "translateY(0)";
    });
  }

  setupFilters() {
    this.filterButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const filter = button.getAttribute("data-filter");

        // Prevent double-clicks on same filter
        if (filter === this.currentFilter) return;

        this.setActiveFilter(filter);
      });
    });

    // Set initial state
    this.setActiveFilter("all");
  }

  setActiveFilter(filter) {
    this.currentFilter = filter;

    // Update active button
    this.filterButtons.forEach((button) => {
      const buttonFilter = button.getAttribute("data-filter");
      if (buttonFilter === filter) {
        button.classList.add("filter-button--active");
        button.setAttribute("aria-pressed", "true");
      } else {
        button.classList.remove("filter-button--active");
        button.setAttribute("aria-pressed", "false");
      }
    });

    // Filter ingredients smoothly
    this.filterIngredients(filter);
  }

  filterIngredients(filter) {
    // Step 1: Determine which cards should be visible
    const cardsToShow = [];
    const cardsToHide = [];

    this.ingredientCards.forEach((card) => {
      const cardCategories = card.getAttribute("data-category");

      if (!cardCategories || cardCategories.trim() === "") {
        cardsToHide.push(card);
        return;
      }

      const categoryArray = cardCategories
        .split(",")
        .map((cat) => cat.trim())
        .filter((cat) => cat.length > 0);

      const shouldShow = filter === "all" || categoryArray.includes(filter);

      if (shouldShow) {
        cardsToShow.push(card);
      } else {
        cardsToHide.push(card);
      }
    });

    // Step 2: Fade out all cards first, then update visibility
    this.fadeOutAllCards(() => {
      this.updateCardVisibility(cardsToShow, cardsToHide);
    });
  }

  fadeOutAllCards(callback) {
    // Fade out all cards simultaneously
    this.ingredientCards.forEach((card) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(10px)";
    });

    // Wait for fade out to complete, then execute callback
    setTimeout(callback, 200);
  }

  updateCardVisibility(cardsToShow, cardsToHide) {
    // First, hide cards that shouldn't be visible (remove from layout)
    cardsToHide.forEach((card) => {
      card.style.display = "none";
    });

    // Show cards that should be visible (add to layout)
    cardsToShow.forEach((card) => {
      card.style.display = "block";
    });

    // Force reflow to ensure display changes take effect
    this.offsetHeight;

    // Then fade in all visible cards with stagger
    cardsToShow.forEach((card, index) => {
      setTimeout(() => {
        card.style.opacity = "1";
        card.style.transform = "translateY(0)";
      }, index * 30); // 30ms stagger between cards
    });
  }
}

// Register the custom element
customElements.define("ingredients-glossary", IngredientsGlossary);
